{
  "version": 1,
  "asset_id": "538b1985-9c12-4e74-8f49-6392a3d5a6bb",
  "project_id": "288ffafd-b4ec-4687-a58e-f3a6c56e4541",
  "url": "/__l5e/assets-v1/538b1985-9c12-4e74-8f49-6392a3d5a6bb/verhuisdozen-inpakservice-team.jpg",
  "r2_key": "a/v1/288ffafd-b4ec-4687-a58e-f3a6c56e4541/538b1985-9c12-4e74-8f49-6392a3d5a6bb/verhuisdozen-inpakservice-team.jpg",
  "original_filename": "verhuisdozen-inpakservice-team.jpg",
  "size": 76299,
  "content_type": "image/jpeg",
  "created_at": "2026-08-27T19:15:01Z"
}
